import {
  useCallback,
  useMemo,
  useContext,
} from 'react';
import { getFirestore } from 'firestorter';

import { firestorePaths } from '../../utils/paths';
import LoggedInUserContext from '../../context/LoggedInUserContext';
import useSessionStore from '../../hooks/useSessionStore';

const useUpdateInteraction = (clientId) => {
  const {
    userDoc: {
      name: authUserName,
    },
    userId: authUserId,
  } = useContext(LoggedInUserContext);
  const { isCoachAssistant: isLoggedInUserCoachAssistant } = useSessionStore();

  const updateLastInteraction = useCallback(async () => {
    if (isLoggedInUserCoachAssistant && clientId) {
      const db = getFirestore();

      const userDocRef = db.collection(firestorePaths.USER).doc(clientId);
      await userDocRef.update({
        lastInteractionBy: authUserId,
        lastInteractionByUserName: authUserName,
      });

      // Update the chat channel of the client with the latest check-in interaction
      const chatChannelCol = await db.collection(firestorePaths.CHAT_CHANNEL)
        .where('userId', '==', clientId)
        .limit(1)
        .get();
      if (!chatChannelCol.empty) {
        const chatChannelDoc = chatChannelCol.docs[0];
        await chatChannelDoc.ref.update({
          lastInteractionBy: authUserId,
        });
      }
    }
  }, [
    isLoggedInUserCoachAssistant,
    clientId,
    authUserId,
    authUserName,
  ]);

  return useMemo(() => ({
    updateLastInteraction,
  }), [
    updateLastInteraction,
  ]);
};

export default useUpdateInteraction;
